<template>
    <div class="erm_form_wrapper">

        <div class="input-wrapper">
            <p class="form-label" for="name"> Name *</p>
            <el-input class="erm_input" v-model="menus.name" style="width: 100%" placeholder="Please Input Name"
                size="large" />
            <p class="error-message" style="margin: 0px 0px 10px 0px;">{{ name_error }}</p>
        </div>

        <div class="input-wrapper">

            <p class="form-label" for="name">Category *</p>
            <el-select class="erm_input" v-model="menus.category_id" placeholder="Category Name" size="large"
                style="width: 100%">
                <el-option v-for="category in categories" :key="category.value" :label="category.name"
                    :value="category.id" />
            </el-select>
            <p class="error-message" style="margin: 0px 0px 10px 0px;">{{ category_error }}</p>
        </div>

        <div class="input-wrapper">
            <p class="form-label" for="name"> Price *</p>
            <el-input class="erm_input" v-model="menus.base_price" style="width: 100%"
                placeholder="Please Input Category Name" size="large" type="number" />
            <p class="error-message" style="margin: 0px 0px 10px 0px;">{{ base_price_error }}</p>
        </div>

        <div class="input-wrapper">
            <p class="form-label" for="name">Portion Sizes</p>
            <PairInput :pair="menus.portion_sizes" />
        </div>

        <div class="input-wrapper">
            <p class="form-label" for="name">Addons</p>
            <PairInput :pair="menus.addons" />
        </div>

        <div class="input-wrapper">
            <p class="form-label" for="name">Availability </p>
            <el-select class="erm_input" v-model="menus.availability" placeholder="Input availability " size="large"
                style="width: 100%;  margin-bottom: 20px;">
                <el-option value="Available" />
                <el-option value="Out of Stock" />
            </el-select>
        </div>

        <div class="input-wrapper">
            <p class="form-label" for="name">Upload Menu Image </p>
            <AppFileUpload :btnTitle="'Upload Image'" v-model:selectedFile="menus.image" />
        </div>

        <div class="input-wrapper">
            <p class="form-label" for="name">Description</p>
            <WpEditor v-model="menus.description" />
            <!-- <el-input class="erm_input" v-model="menus.description" style="width: 100%;"
                placeholder="Please Input Description" size="large" type="textarea" /> -->
        </div><br>

        <div class="input-wrapper" @click="saveMenu()">
            <el-button size="large" type="primary">Save Menu</el-button>
        </div>

    </div>
</template>

<script>
import axios from "axios";
import AppFileUpload from "../../components/AppFileUpload.vue";
import PairInput from "../../components/PairInput.vue";
import WpEditor from "../../components/WpEditor.vue";
export default {
    components: {
        AppFileUpload,
        PairInput,
        WpEditor
    },
    data() {
        return {
            nonce: window.RestaurantMenuMangeData.nonce,
            menus: {
                name: "",
                category_id: "",
                base_price: "",
                portion_sizes: [{ name: "small" , value: "200"}],
                addons: [{ name: "Cheese" , value: "50"}],
                availability: "",
                description: "",
                image: "",
                branch_id: window.RestaurantMenuMangeData.branch_id,
            },
           

            categories: "",
            category_error: "",
            name_error: "",
            base_price_error: "",
            rest_api: window.RestaurantMenuMangeData.rest_api,
        };
    },
    props: {
        menus_data: {
            type: Object,
        }
    },
    watch: {
        menus_data: {
            handler: function (val) {
                this.menus = val;
            },
            deep: true
        }
    },

    methods: {
        handleFileUpload(event) {
            const file = event.target.files[0];
            if (file) {
                this.image = file;
                console.log("Selected file:", file);
            } else {
                console.error("File selection failed.");
            }
        },

        async saveMenu() {
            this.name_error = "";
            this.category_error = "";
            this.base_price_error = "";
            if (!this.menus.name) {
                this.name_error = "Menu name is required";
                return;
            }
            if (!this.menus.category_id) {
                this.category_error = "Category is required";
                return;
            }
            if (!this.menus.base_price) {
                this.base_price_error = "Price is required";
                return;
            }


            this.menus.portion_sizes = JSON.stringify(this.menus.portion_sizes);
            this.menus.addons = JSON.stringify(this.menus.addons);
           

            try {
                const response = await axios.post(`${this.rest_api}/postMenu`, {
                    data:this.menus,
                    name: this.menus.name,
                    branch_id: this.menus.branch_id,
                    category_id: this.menus.category_id,
                    description: this.menus.description,
                    base_price: this.menus.base_price,
                    image: this.menus.image,
                    portion_sizes: this.menus.portion_sizes,
                    addons: this.menus.addons,
                    availability: this.menus.availability,
                },{
                    headers: {
                        'Content-Type': 'application/json',
                        'X-WP-Nonce': this.nonce
                    }
                });
                console.log('Menus:', response.data);
                this.$emit("updateDataAfterNewAdd", this.menus);
               
                this.menus = {
                    name: "",
                    category_id: "",
                    description: "",
                    base_price: "",
                    portion_sizes: "",
                    addons: "",
                    availability: "",
                };
            } catch (error) {
                console.error("Error submitting menu:", error);
            }
        },

        async getCategory() {
            this.loading = true;
            try {
                const response = await axios.get(`${this.rest_api}/getCategory`, {
                    headers: {
                        'X-WP-Nonce': this.nonce
                    }
                });
                this.categories = response.data?.category_data;
                this.loading = false;
            } catch (error) {
                this.loading = false;
                console.error('Error fetching couriers:',);
            }
        },


    },

    mounted() {
        if (this.menus_data) {
            console.log('menus:', this.menus_data);
            this.menus = this.menus_data;
        }
        this.getCategory();
    }

};
</script>